import React, { useEffect } from "react";
import { propertiesStore } from "properties/_stores/propertiesStore";
import { TFilter } from "admin/_common/filters/TFilter";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { getPageNumberFromUrl } from "_common/_utils/pageUtils";
import { useLocation } from "react-router";
import { observer } from "mobx-react";
import { PropertiesList } from "virtualAssistant/PropertiesList";

type Props = {
    filters: TFilter[];
};
export const VirtualAssistantSummaryLoader = observer(({ filters }: Props) => {
    const location = useLocation();

    const listStore = propertiesStore.getListStore(
        "virtual-assistant-summary",
        undefined,
        filters,
        true,
        true,
        undefined,
        getPageNumberFromUrl(location.pathname) ?? 1,
    );
    useEffect(() => {
        listStore.load();
    }, []);

    return (
        <>
            {listStore.currentLoadingState ? (
                <LoadableFromLoading
                    loading={listStore.currentLoadingState}
                    renderer={() => {
                        return <PropertiesList listStore={listStore} />;
                    }}
                />
            ) : (
                <PropertiesList listStore={listStore} />
            )}
        </>
    );
});
